// @flow

import React, { type Node } from 'react';
import { getSafePaymentType, getSafePaymentTypeCode, useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';

import { AchPsePage } from './achpse-page';
import { CardPage } from './card-page';
import { LatamPage } from './latam-page';
import { BrazilianPage } from './brazilian-page';
import { EnglishPage } from './english-page';

import { ArabicPage } from './arabic-page';

export function PageContent(): Node {
  const incomingPayment = useIncomingPayment();
  const paymentType = getSafePaymentType(incomingPayment);
  const paymentTypeCode = getSafePaymentTypeCode(incomingPayment);
  const country = getCountry(incomingPayment);

  if (paymentType === 'creditcard') {
    return <CardPage />;
  }

  switch (country) {
    case 'br':
      return <BrazilianPage />;

    case 'ar':
    case 'bo':
    case 'co':
      if (paymentTypeCode === 'achpse') {
        return <AchPsePage />;
      }
      return <LatamPage />;
    case 'cl':
    case 'ec':
    case 'mx':
    case 'pe':
    case 'uy':
      return <LatamPage />;

    case 'eg':
      return <ArabicPage />;

    case 'za':
    case 'ke':
    case 'ng':
    case 'in':
    case 'tz':
    case 'ug':
    case 'zm':
    case 'gh':
    case 'jm':

      return <EnglishPage />;

    default:
      throw new Error(`Confirmed Page: country: ${country} is not mapped`);
  }
}
